module.exports = __webpack_public_path__ + "static/pdf_icon-de5bcaa047bdbb12a2959506a1560f0a.png";